// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	CreateAccountLink: 'create-account-link',
	Email: 'email',
} as const;
